<template>
  <LoadingCard v-if="loading" />
  <Alert v-else-if="globalMessage">{{ globalMessage }}</Alert>
  <Alert v-else-if="order &&!canEdit">{{__('order_cannot_be_changed')}}</Alert>
  <template v-else>
    <template v-if="!isRoomView && !isPayReturnView">
      <SelectedRoomHeader />
      <PageTree v-if="!isCancelRequestedView" />
    </template>

    <Room v-if="isRoomView" />
    <CancelRequested v-else-if="isCancelRequestedView" />
    <UserDetails v-else-if="isUserDetailsView" />
    <AmountService v-else-if="isAmountServiceView" />
    <SelectService v-else-if="isSelectServiceView" />
    <Overview v-else-if="isOverviewView" />
    <Pay v-else-if="isPayView" />
    <BankReturn v-else-if="isPayReturnView" />
  </template>
</template>

<script>
import { onMounted, ref, watch } from 'vue'
import { globalMessage } from '@/stores/Global'
import { loadData as loadRoomData } from '@/stores/Rooms'
import {
  order,
  checkOrder,
  isCancelRequested,
  totalPrice,
  totalPayNowPrice,
  currency,
  canEdit
} from '@/stores/Order'
import {
  isUserDetailsView,
  isRoomView,
  isAmountServiceView,
  setUserDetailsView,
  isSelectServiceView,
  isOverviewView,
  isPayView,
  setPayReturnView,
  isPayReturnView,
  setCancelRequestedView,
  isCancelRequestedView,
} from '@/stores/View'
import LoadingCard from '@/components/LoadingCard'
import Alert from '@/components/Alert'
import Room from '@/components/Room/List'
import UserDetails from '@/components/UserDetails'
import AmountService from '@/components/AmountService/List'
import SelectService from '@/components/SelectService/List'
import Overview from '@/components/Overview'
import Pay from '@/components/Pay'
import BankReturn from '@/components/BankReturn'
import SelectedRoomHeader from '@/components/SelectedRoomHeader'
import PageTree from '@/components/PageTree/List'
import CancelRequested from '@/components/CancelRequested'
import __ from '@/libraries/Translation'
import { formatPrice } from '@/libraries/Helpers'

export default {
  name: 'App',
  components: {
    LoadingCard,
    Alert,
    Room,
    UserDetails,
    AmountService,
    SelectService,
    Overview,
    Pay,
    BankReturn,
    SelectedRoomHeader,
    PageTree,
    CancelRequested,
  },
  setup() {
    const loading = ref(true)

    onMounted(async () => {
      if (window.room_rent.from_bank) {
        setPayReturnView()
        loading.value = false
      } else {
        const { success: orderSuccess } = await checkOrder()

        if (orderSuccess) {
          if (isCancelRequested.value) {
            setCancelRequestedView()
          } else {
            setUserDetailsView()
          }
        }
        await loadRoomData()
        loading.value = false

        let orderInterval
        watch(
          order,
          (order) => {
            if (order.expires_at) {
              window.parent.postMessage(
                JSON.stringify({
                  key: 'shop_purchase_timer',
                  expires_at: order.expires_at,
                  extraData: [
                    {
                      title: __('title_pay_now_price'),
                      value: `${currency} ${formatPrice(
                        totalPayNowPrice.value
                      )}`,
                    },
                    {
                      title: __('title_total_price'),
                      value: `${currency} ${formatPrice(totalPrice.value)}`,
                    },
                  ],
                }),
                '*'
              )
              clearInterval(orderInterval)
              if (!order.edit_mode) {
                orderInterval = setInterval(async () => {
                  if (Date.now() > order.expires_at + 20) {
                    await checkOrder()
                    clearInterval(orderInterval)
                  }
                }, 1000)
              }
            } else {
              clearInterval(orderInterval)
              window.parent.postMessage(
                JSON.stringify({
                  key: 'shop_purchase_timer',
                  expires_at: null,
                  extraData: [],
                }),
                '*'
              )
            }
          },
          {
            immediate: true,
          }
        )

        watch([totalPayNowPrice, totalPrice], () => {
          if (order.value && order.value.expires_at) {
            window.parent.postMessage(
              JSON.stringify({
                key: 'shop_purchase_timer',
                expires_at: order.value.expires_at,
                extraData: [
                  {
                    title: __('title_pay_now_price'),
                    value: `${currency} ${formatPrice(totalPayNowPrice.value)}`,
                  },
                  {
                    title: __('title_total_price'),
                    value: `${currency} ${formatPrice(totalPrice.value)}`,
                  },
                ],
              }),
              '*'
            )
          }
        })
      }
    })

    return {
      loading,
      globalMessage,
      isRoomView,
      isUserDetailsView,
      isAmountServiceView,
      isSelectServiceView,
      isOverviewView,
      isPayView,
      isPayReturnView,
      isCancelRequestedView,
      canEdit,
      order
    }
  },
}
</script>
